<script>
    import PageTitle from '../components/PageTitle.svelte';
    import EditFooterLinks from '../components/EditFooterLinks.svelte';
</script>

<PageTitle text={'Edit Footer'} />

<div class="form-wrapper">
    <h4>Edit Footer Links</h4>
    <EditFooterLinks />
</div>

<style>
    h4 {
        color: var(--off-black);
        margin-bottom: 15px;
    }
</style>
